module.exports = __webpack_public_path__ + "media/images/flags/gr-e2d0116790bdfda46fb4cdedc74b5b53.svg";